import { render } from "./RegisterContracts.vue?vue&type=template&id=c082d16e&scoped=true&ts=true"
import script from "./RegisterContracts.vue?vue&type=script&lang=ts"
export * from "./RegisterContracts.vue?vue&type=script&lang=ts"

import "./RegisterContracts.vue?vue&type=style&index=0&id=c082d16e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c082d16e"]])

export default __exports__